export default __webpack_public_path__ + "d4f35140444ef0f4a7bd890f5359f0a5.png";